import { useQuery } from "@tanstack/react-query";

import { Organization, api } from "@/lib/api";
import { unwrapAxiosData } from "@/lib/api/query-utils";

export const keys = {
  organisation: (organisationId: string) =>
    ["organisation", organisationId, "organisation"] as const,
  organisations: ["organisations"],
};

export const useOrganisationQuery = (organisationId: string) => {
  return useQuery({
    queryKey: keys.organisation(organisationId),
    queryFn: (): Promise<Organization> =>
      unwrapAxiosData(api.organizations.getOrganization(organisationId)),
  });
};

export const useOrganisationsQuery = () => {
  return useQuery({
    queryKey: keys.organisations,
    queryFn: (): Promise<Organization[]> =>
      unwrapAxiosData(api.organizations.getOrganizations()),
  });
};
